import React, { useState, useLayoutEffect, useRef } from "react";
import { FiChevronDown, FiChevronUp } from "react-icons/fi";
import OutsideClickHandler from "react-outside-click-handler";

const RoleDropDown = ({ selectedRole, onSelect, isOpen }) => {
  const triggerRef = useRef(null);
  const [menuStyle, setMenuStyle] = useState({ visibility: "hidden" });

  const handleTypeClick = (index) => {
    onSelect(index);
  };

  useLayoutEffect(() => {
    if (!isOpen) {
      setMenuStyle((prev) => ({ ...prev, visibility: "hidden" }));
      return;
    }
    if (!triggerRef.current) return;

    const updateMenuPosition = () => {
      const rect = triggerRef.current.getBoundingClientRect();
      setMenuStyle({
        position: "fixed",
        top: rect.bottom + 0,
        left: rect.left,
        width: rect.width,
        zIndex: 9999,
        visibility: "visible",
      });
    };

    updateMenuPosition();
    const raf = requestAnimationFrame(updateMenuPosition);
    window.addEventListener("resize", updateMenuPosition);
    window.addEventListener("scroll", updateMenuPosition, true);

    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener("resize", updateMenuPosition);
      window.removeEventListener("scroll", updateMenuPosition, true);
    };
  }, [isOpen]);

  return (
    <OutsideClickHandler
      onOutsideClick={() => {
        onSelect(-1);
      }}
    >
      <div className="relative w-full">
        <button
          ref={triggerRef}
          onClick={(e) => {
            onSelect(-2);
          }}
          className="w-full flex items-center h-[30px] justify-between px-4 py-2 border rounded-[6px] text-gray-800 focus:outline-none focus-visible:outline-none focus:ring-0"
        >
          <span className="font-OpenSansRegular text-[400] text-[12px] text-titleColor">{selectedRole}</span>
          {isOpen ? <FiChevronUp className="ml-2" size={15} /> : <FiChevronDown className="ml-2" size={15} />}
        </button>
        {isOpen && (
          <ul style={menuStyle} className="bg-white border rounded-md shadow-lg">
            <li
              key={0}
              onClick={() => handleTypeClick(0)}
              className="px-4 py-2 cursor-pointer hover:bg-gray-200 font-OpenSansRegular text-[12px]"
            >
              Primary technician
            </li>

            <li
              key={1}
              onClick={() => handleTypeClick(1)}
              className="px-4 py-2 cursor-pointer hover:bg-gray-200 font-OpenSansRegular text-[12px]"
            >
              Technician
            </li>
          </ul>
        )}
      </div>
    </OutsideClickHandler>
  );
};

export default RoleDropDown;
